const styles = {
  tablesWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  table: {
    width: "100%",
    minWidth: "100%",
    whiteSpace: "nowrap",
    mt: "20px",
  },
  tableCell: {
    p: "6px",
  },
  tableHeadCell: {
    color: "text.secondary",
    width: "30%",
  },
};

export default styles;
